<!-- src/components/GlobalWarningDrawer.vue -->
<template>
  <el-drawer :visible.sync="drawerVisible" direction="rtl" size="350px" :show-close="false" :modal="false"
    :wrapperClosable="true" custom-class="warning-drawer" :with-header="false">
    <div class="drawer-content">
      <div class="drawer-header">
        <h3>库存预警</h3>
      </div>
      <div class="drawer-body">
        <p>部分商品库存严重不足，请立即补货！</p>
      </div>
      <div class="drawer-footer">
        <el-button @click="drawerVisible = false">稍后处理</el-button>
        <el-button type="primary" @click="handleReplenish">去补货</el-button>
      </div>
    </div>
  </el-drawer>

</template>

<script>
  import { pageWarn } from "@/api/customPageClass.js";

  export default {
    name: "GlobalWarningDrawer",
    data() {
      return {
        drawerVisible: false,
        companyName: null
      };
    },
    mounted() {
      let userInfo = JSON.parse(localStorage.getItem('info'));
      this.userInfo = userInfo
      if (this.userInfo.companyList) {
        this.companyName = this.userInfo.companyList[0].companyName
      }
      this.checkWarnings();
    },
    methods: {
      checkWarnings() {
        pageWarn().then(res => {
          if (res.code === 200 && res.data.list.length > 0 && this.companyName.includes('利佳')) {
            this.drawerVisible = true;
          }
        }).catch(err => {
          console.error("获取预警信息失败:", err);
        });
      },
      handleReplenish() {
        this.drawerVisible = false;
        // 触发事件，让父组件处理跳转逻辑
        // this.$emit('replenish');
        this.$router.push({ name: 'productWarning' });
      }
    }
  };
</script>

<style scoped>
  .drawer-content {
    padding: 20px;
    height: 100%;
    display: flex;
    flex-direction: column;
    max-height: calc(100vh / 5);
  }

  .drawer-header {
    border-bottom: 1px solid #eee;
    padding-bottom: 15px;
  }

  .drawer-header h3 {
    margin: 0;
    color: #e64545;
  }

  .drawer-body {
    flex: 1;
    font-size: 16px;
    color: #333;
    margin: 10px 0;
  }

  .drawer-footer {
    text-align: right;
  }

  .drawer-footer .el-button {
    margin-left: 10px;
  }
</style>

<style>
  .warning-drawer {
    z-index: 2000 !important;
    top: 80px !important;
    bottom: auto !important;
    height: calc(100vh / 4) !important;
  }

  .el-drawer__header {
    margin: 0 !important;
  }

  .warning-drawer .el-drawer__body {
    padding: 0;
  }

  .warning-drawer .drawer-header {
    margin-bottom: 10px;
  }

  .warning-drawer .drawer-footer {
    margin-top: 10px;
  }

  .warning-drawer {
    z-index: 2000 !important;
    position: fixed;
    /* 确保不随父容器滚动 */
    top: 80px !important;
    /* 避开顶部导航栏（假设导航栏高80px） */
    right: 0;
    width: 350px;
    height: auto;
    max-height: calc(100vh - 120px);
    /* 调整最大高度，减少上下边距 */
    /* 留出上下空间 */
    overflow-y: auto;
  }

  .warning-drawer .el-drawer__body {
    padding: 20px;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
</style>